<template>
    <div>
        <div class="contents">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="breadcrumb-main user-member justify-content-sm-between ">
                            <div class=" d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                                <div
                                    class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                    <h4 class="text-capitalize fw-500 breadcrumb-title">Detail Paket</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div v-if="!isLoading"
                            class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                            <form v-on:submit.prevent="editPackage">
                                <label for="">Nama Paket*</label>
                                <input type="text" class="form-control" v-model="form.name" placeholder="Nama Paket" required />
                                <br>
                                <label for="">Max Device*</label>
                                <input type="number" class="form-control" v-model="form.max_device" required />
                                <br>
                                <label for="">Max CS*</label>
                                <input type="number" class="form-control" v-model="form.max_cs" required />
                                <br>
                                <label for="">Max Link Rotator*</label>
                                <input type="number" class="form-control" v-model="form.max_link_rotator" required />
                                <br>
                                <label for="">Durasi (Hari)*</label>
                                <input type="number" class="form-control" v-model="form.duration" required />
                                <br>
                                <label for="">Harga (Rupiah)*</label>
                                <input type="number" class="form-control" v-model="form.price" required />
                                <br>
                                <div class="button-group d-flex pt-25">
                                    <button type="submit"
                                        class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
                                        simpan
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div v-else class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                            <center>
                                <div class="spinner-border spinner" role="status"></div>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                id: '',
                form: {
                    name: null,
                    max_device: null,
                    max_cs: null,
                    max_link_rotator: null,
                    duration: null,
                    price: null,
                },
                originalData: {},
                isLoading: true,
            };
        },
        async mounted() {
            this.id = this.$route.query.id
            await this.loadData()
        },
        methods: {
            async editPackage(){
                try{
                    // Parse Data JSON if exists to get additional fields
                    let additionalData = {}
                    if (this.originalData.data) {
                        try {
                            additionalData = JSON.parse(this.originalData.data)
                        } catch (e) {
                            additionalData = {}
                        }
                    }

                    // Use original data for fields that are not in the simplified form
                    let req = {
                        id: this.id,
                        name: this.form.name,
                        lisensi: this.originalData.lisensi ?? 1,
                        message_quota: this.originalData.message_quota ?? -1,
                        max_device: parseInt(this.form.max_device ?? 0),
                        max_cs: parseInt(this.form.max_cs ?? 0),
                        max_campaign: additionalData.max_campaign ?? 0,
                        max_order_online: additionalData.max_order_online ?? 0,
                        max_link_rotator: parseInt(this.form.max_link_rotator ?? 0),
                        max_chat_widget: additionalData.max_chat_widget ?? 0,
                        is_addon: additionalData.is_addon ?? 0,
                        duration: parseInt(this.form.duration ?? 30),
                        price: parseInt(this.form.price ?? 0),
                        hide: this.originalData.hide ?? 0,
                        webhook_media_quota: additionalData.webhook_media_quota ?? 0,
                        whitelist: additionalData.whitelist ?? []
                    }

                    let response = await this.$store.dispatch('admin_package_update', req)
                    this.$toast.success(response.data.message);

                    await this.loadData()
                }catch(err){
                    this.$toast.error(err.response.data.message);
                }
            },
            async loadData() {
                try {
                    let id = this.$route.query.id
                    let detail = await this.$store.dispatch("admin_package_detail", {
                        id: id
                    })
                    let packageData = detail.data.data.package
                    
                    // Store original data for preserving other fields
                    this.originalData = {...packageData}
                    
                    // Only set the fields we want to show in the form
                    this.form = {
                        name: packageData.name,
                        max_device: packageData.max_device,
                        max_cs: packageData.max_cs,
                        max_link_rotator: packageData.max_link_rotator,
                        duration: packageData.duration,
                        price: packageData.price,
                    }

                    this.isLoading = false
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                    this.$router.push("/admin/paket")
                }
            },
        },
    };
</script>

<style scoped>
    
</style>
